import React from 'react'

import { Link } from 'gatsby'
import { Layout, Showcase, Header, SectionTitle } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default props => {
  const code = null

  return (
    <>
      <Header
        site={data.site}
        state="design"
        slug={data.slug + '/design/'}
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <SectionTitle>Structure</SectionTitle>
        <Showcase
          site={data.site}
          title="Footer"
          text={
            <p>
              The footer displays copyright and legal verbiage and provides
              links to the bank's Accessibility standards, Terms of Use and
              Privacy Policy. The Equal Housing and Entrust logos also link away
              to the appropriate pages. If you want the footer to always be at
              the bottom of the page, you can look here for{' '}
              <Link
                to={'/' + data.site + '/layout/container/design/'}
                className="c-link"
              >
                Sticky Footer
              </Link>
            </p>
          }
        >
          <div class="full-width">
            <footer class="p-main-footer">
              <div class="p-main-footer__content">
                <p class="p-main-footer__paragraph">
                  <a
                    href="https://www3.mtb.com/help-center/accessibility-policy"
                    target="_blank"
                    class="p-main-footer__link"
                  >
                    Accessibility
                  </a>
                </p>
                <p class="p-main-footer__paragraph">
                  © 2022 M&amp;T Bank. All rights reserved.
                </p>
                <p class="p-main-footer__paragraph">
                  Users of this website agree to be bound by the provisions of
                  the M&amp;T website{' '}
                  <a
                    href="https://www.mtb.com/help-center/policies/terms-of-use"
                    target="_blank"
                    class="p-main-footer__link"
                  >
                    Terms of Use
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://www.mtb.com/help-center/policies/privacy-policy"
                    target="_blank"
                    class="p-main-footer__link"
                  >
                    Privacy
                  </a>
                  .
                </p>
                <div class="p-main-footer__images">
                  <svg
                    width="125"
                    height="20"
                    viewBox="0 0 125 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.6522 0L27 7.75668V10.4563H24.8705V20H2.0915V10.4563H0V7.68068L13.6522 0ZM13.6513 2.89227L4.86684 7.98727V17.5689H22.2456V7.98727L13.6513 2.89227Z"
                      fill="#767676"
                    />
                    <path
                      d="M8.97925 11.6359H18.0678V9.27858H8.97925V11.6359Z"
                      fill="#767676"
                    />
                    <path
                      d="M8.97925 15.1468H18.0678V12.7893H8.97925V15.1468Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M39.9056 0.433357V19.5423H51.0363V14.529H45.6267V12.3505H50.5303V7.34018H45.6267V5.44246H51.0363V0.433357H39.9056Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M61.2179 4.36447C59.3972 4.36447 57.965 5.88618 57.4352 7.49641L57.3746 7.43499L57.5161 4.67784H52.0201V19.5422H57.5161V12.392C57.5161 10.8696 57.6011 9.85641 58.6687 9.85641C59.5926 9.85641 59.6769 10.7558 59.6769 12.0232V19.5422H65.1728V9.7439C65.1728 7.06874 64.389 4.36447 61.2179 4.36447Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M80.5144 7.5713L80.4588 7.51822L80.7674 4.67784H72.6651V1.39566H67.1666V4.67784H65.5909V9.0967H67.1666V19.5422H72.6651V9.0967H75.2417V19.5422H80.7368V13.5158C80.7368 11.9683 80.9897 9.99822 83.0382 9.99822C83.4329 9.99822 84.075 10.2774 84.5809 10.5333V4.36448C82.5323 4.28372 81.1315 5.74865 80.5144 7.5713Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M93.278 12.673C93.278 14.4755 93.1667 15.2324 92.1856 15.2324C91.2378 15.2324 91.1238 14.447 91.1238 12.673V4.67782H85.626V13.4332C85.626 17.4838 87.9218 19.8502 92.1856 19.8502C96.2242 19.8502 98.7786 17.825 98.7786 13.4332V4.67782H93.278V12.673Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M106.445 10.3924C105.855 10.1689 104.791 9.77284 104.791 9.01151C104.791 8.5317 105.21 8.28355 105.602 8.28355C106.531 8.28355 107.256 9.01151 107.904 9.6044L109.783 5.57881C108.493 4.84449 106.753 4.36449 105.269 4.36449C101.817 4.36449 99.3207 6.31056 99.3207 9.37767C99.3207 11.914 101.036 13.0377 103.193 13.7968C104.146 14.1383 104.624 14.447 104.624 14.9804C104.624 15.5154 104.032 15.7427 103.557 15.7427C102.548 15.7427 101.455 14.8952 100.808 14.1926L98.7898 18.3053C100.527 19.2606 102.097 19.8502 104.118 19.8502C107.176 19.8502 110.03 17.9954 110.03 14.642C110.03 12.2239 108.437 11.1512 106.445 10.3924Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M117.685 4.67785V1.39567H112.19V4.67785H110.62V9.09671H112.19V19.5422H117.685V9.09671H119.508V4.67785H117.685Z"
                      fill="#767676"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M122.082 3.72582C121.137 3.72582 120.381 2.97217 120.381 2.02847C120.381 1.08421 121.137 0.333688 122.082 0.333688C123.013 0.333688 123.761 1.08421 123.761 2.02847C123.761 2.97217 123.013 3.72582 122.082 3.72582ZM122.082 3.96222C123.138 3.96222 124 3.09151 124 2.02847C124 0.957764 123.138 0.0948257 122.082 0.0948257C121.009 0.0948257 120.142 0.957764 120.142 2.02847C120.142 3.09151 121.009 3.96222 122.082 3.96222ZM122.385 2.14933C122.755 2.14099 123.044 1.98582 123.044 1.56999C123.044 1.21862 122.852 1.00857 122.296 1.00857H121.379V3.12648H121.612V2.14933H122.11L122.71 3.12648H123.019L122.385 2.14933ZM121.612 1.91018V1.24582H122.232C122.494 1.24582 122.808 1.28829 122.808 1.56222C122.808 1.96004 122.327 1.91018 122.027 1.91018H121.612Z"
                      fill="#767676"
                    />
                  </svg>
                </div>
                <p class="p-main-footer__paragraph">
                  Equal Housing Lender. NMLS #381076.
                </p>
                <p class="p-main-footer__paragraph">
                  <a
                    href="https://www3.mtb.com/help-center/accessibility-policy"
                    target="_blank"
                    class="p-main-footer__link"
                  >
                    Member FDIC.
                  </a>
                </p>
              </div>
            </footer>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*
  checkbox: `<footer class="p-main-footer">
    <div class="p-main-footer__content">
        <p class="p-main-footer__paragraph--first">© 2019 M&amp;T Bank. All rights reserved.  Users of this website agree to be bound by the provisions of the M&amp;T website <a href="https://www.mtb.com/help-center/policies/terms-of-use" target="_blank" class="p-main-footer__link">Terms of Use</a> and <a href="https://www.mtb.com/help-center/policies/privacy-policy" target="_blank" class="p-main-footer__link">Privacy</a>.</p>
        <div class="p-main-footer__images">
            <svg width="65px" height="59px" viewBox="0 0 65 59" version="1.1">
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Artboard" fill="#787878">
                        <path d="M33.22552,15 L13,26.5103097 L13,30.6698474 L16.098522,30.6698474 L16.098522,44.9721261 L49.8451281,44.9721261 L49.8451281,30.6698474 L53,30.6698474 L53,26.6242136 L33.22552,15 Z M20.2101382,26.9697782 L33.2240751,19.3343668 L45.9565034,26.9697782 L45.9565034,41.3288884 L20.2101382,41.3288884 L20.2101382,26.9697782 Z M26.30267,32.4376449 L39.7671653,32.4376449 L39.7671653,28.9049396 L26.30267,28.9049396 L26.30267,32.4376449 Z M26.30267,37.6991361 L39.7671653,37.6991361 L39.7671653,34.1661901 L26.30267,34.1661901 L26.30267,37.6991361 Z" id="Page-1-Copy"></path>
                    </g>
                </g>
            </svg>
        </div>
        <p class="p-main-footer__paragraph--last">Equal Housing Lender. M&amp;T Bank, Member FDIC.</p>
    </div>
</footer>
`,*/
}
